import { render, staticRenderFns } from "./AccountFunplus.vue?vue&type=template&id=5d5917fa&scoped=true"
import script from "./AccountFunplus.vue?vue&type=script&lang=js"
export * from "./AccountFunplus.vue?vue&type=script&lang=js"
import style0 from "./AccountFunplus.vue?vue&type=style&index=0&id=5d5917fa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5917fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5917fa')) {
      api.createRecord('5d5917fa', component.options)
    } else {
      api.reload('5d5917fa', component.options)
    }
    module.hot.accept("./AccountFunplus.vue?vue&type=template&id=5d5917fa&scoped=true", function () {
      api.rerender('5d5917fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AccountFunplus.vue"
export default component.exports